import React, { useState } from 'react';
import './ApiKeyPrompt.css';

function ApiKeyPrompt({ onSubmit }) {
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!apiKey.trim()) {
      setError('API key is required');
      return;
    }
    onSubmit(apiKey.trim());
  };

  return (
    <div className="api-key-overlay">
      <div className="api-key-modal">
        <h2>Authentication Required</h2>
        <p>Please enter your API key to access the ValidationTool</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={apiKey}
            onChange={(e) => {
              setApiKey(e.target.value);
              setError('');  // Clear error on change
            }}
            placeholder="Enter API key"
            className="api-key-input"
            autoFocus
          />
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="btn-submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default ApiKeyPrompt;
